const GooglePhone = require('google-libphonenumber');

const PhoneUtil = GooglePhone.PhoneNumberUtil.getInstance();

const internals = {};

internals.buildPhoneField = () => ({
    type: 'TextField',
    name: 'phone',
    label: 'Mobile Number',
    fullWidth: true,
    rules: {
        validate: (value) => {

            if (!value) {
                return 'Phone number is required';
            }

            try {
                return PhoneUtil.isValidNumber(PhoneUtil.parse(value, 'us'))
                    ? true
                    : 'Enter a valid phone number';
            }
            catch (err) {
                return 'Enter a valid phone number';
            }
        }
    },
    textFieldProps: {
        id: 'mfa-phone-input',
        type: 'tel',
        autoComplete: 'off',
        placeholder: '(555) 555-5555'
    }
});

internals.MFA_CODE_LENGTH = 6;

internals.normalizeMfaCode = (value) => String(value || '').replace(/\D/g, '').slice(0, internals.MFA_CODE_LENGTH);

internals.buildCodeField = () => ({
    type: 'TextField',
    name: 'code',
    label: 'Verification Code',
    fullWidth: true,
    maxLength: internals.MFA_CODE_LENGTH,
    rules: {
        validate: (value) => {

            const code = internals.normalizeMfaCode(value);

            if (!code) {
                return 'Verification code is required';
            }

            if (code.length !== internals.MFA_CODE_LENGTH) {
                return 'Enter the 6-digit verification code';
            }

            return true;
        }
    },
    onChange: internals.normalizeMfaCode,
    textFieldProps: {
        id: 'mfa-code-input',
        autoComplete: 'off',
        inputProps: {
            inputMode: 'numeric',
            maxLength: internals.MFA_CODE_LENGTH,
            pattern: '[0-9]*'
        }
    }
});

module.exports.buildDefaults = ({
    code = '',
    needsPhone = false,
    phone = ''
} = {}) => needsPhone ? { phone } : { code };

module.exports.buildFormConfig = ({
    defaults,
    formId,
    needsPhone,
    onSubmit
}) => ({
    defaults,
    fields: [
        needsPhone
            ? internals.buildPhoneField()
            : internals.buildCodeField()
    ],
    formId,
    onSubmit
});
